import React, {
    useContext,
    useCallback,
    useState,
    useEffect
} from 'react';
import _ from 'lodash';
import { wizardProps } from '@xengage/gw-portals-wizard-react';

import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useDependencies } from '@xengage/gw-portals-dependency-react';
import { ClausesUtil } from '@xengage/gw-policycommon-util-js';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
// import { CodegenContext } from '../../components/CodegenContext';
import presentationMetadata from './CoveragesPage.metadata.json5';
import './CoveragesPage.messages';
import styles from '../../HoleInOnePage.module.scss';
import { BreakpointTrackerContext } from '@jutro/legacy/layout';

function CoveragesPage(props) {
    const { authHeader } = useAuthentication();
    const [loadingClause, updateLoadingClause] = useState();
    const {
        wizardData: submissionVM, updateWizardData, isEditable = true, clausesBasePath, title, clasueType, pathToGet
    } = props;
    const { LoadSaveService } = useDependencies('LoadSaveService');
    const { EndorsementService } = useDependencies('EndorsementService');
    const metadata = presentationMetadata["SpeLinProduct.default.coverages"];
    const breakpoint = useContext(BreakpointTrackerContext);
    const {
        onValidate,
        registerComponentValidation,
        registerInitialComponentValidation
    } = useValidation('CoveragesPage');

    const changeSubmission = useCallback(
        (value, changedPath) => {
            // value = LocalDateUtil.changeDateFormatForDirectDateValue(value, changedPath);
            updateWizardData(
                ClausesUtil.setClauseValue(submissionVM, value, changedPath)
            );
        },
        [submissionVM, updateWizardData]
    );


    const syncCoverages = useCallback(async (value, changedPath) => {
        updateLoadingClause(true)
        
        const { jobType } = submissionVM.value.baseData;
        const jobService = jobType === 'PolicyChange' ? EndorsementService : LoadSaveService;
        const { quoteID, jobID, sessionUUID } = submissionVM.value;
        const lobName = ClausesUtil.getLobNameFromPath(clausesBasePath);

        const clausesToUpdate = [clasueType].reduce((payloadToSend, clauseType) => {
            let clausePathValue = _.get(submissionVM, `${clausesBasePath}.value`);

            if (!clausePathValue) {
                clausePathValue = _.get(submissionVM.value, `${clausesBasePath}.${clauseType}`);
            }

            const clauses = clausePathValue || [];

            return _.merge(
                payloadToSend,
                ClausesUtil.structureClausesForServer(clauses, lobName, clauseType)
            );
        }, {});

        const res = await jobService.updateCoverages(quoteID || jobID, sessionUUID, clausesToUpdate, authHeader);// await updateClauses();
        const clausesBasePathTemp = clausesBasePath.indexOf('children') !== -1 ? clausesBasePath.replace('.children', '') : clausesBasePath
        const updatedCov = _.get(res, pathToGet)
        
        _.set(submissionVM.value, clausesBasePathTemp, updatedCov)
        
        updateLoadingClause(false)
        updateWizardData(submissionVM);

    }, [submissionVM, EndorsementService, LoadSaveService, clausesBasePath, clasueType, authHeader, pathToGet, updateWizardData]);


    const changeSubmissionAndSync = useCallback(
        (value, changedPath) => {
             if (!_.isUndefined(value.target)) {
                const dateValue = new Date()

                dateValue.setHours(value.target.value.hour)
                dateValue.setMinutes(value.target.value.minute)
                changeSubmission(dateValue, value.target.name);
                syncCoverages(dateValue, value.target.name);
            } else {
                changeSubmission(value, changedPath);
                syncCoverages(value, changedPath);
            }
        },
        [changeSubmission, syncCoverages]
    );

    const resolvers = {
        resolveCallbackMap: {
            onChangeClause: changeSubmission,
            onSyncCoverages: syncCoverages,
            onChangeSubmissionAndSync: changeSubmissionAndSync,
            onValidate,
        },
        resolveClassNameMap: styles
    };

    const overrideProps = {
        '@field': {
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top',
        },
        coverages: {
            loadingClause,
            path: `${clausesBasePath}`,
            isEditable,
            value: _.get(submissionVM, `${clausesBasePath}.value`)
        },
        coverageAccordionDetails: {
            title
        }
    };

    const shouldPageSkip = useCallback(() => {
        const coverages = _.get(submissionVM.value, clausesBasePath);
        const jobType = _.get(submissionVM.value, 'baseData.jobType');

        if (jobType === 'Submission') {
            return true;
        }

        const status = _.get(submissionVM.value, 'status');

        return status === 'Quoted' || (coverages && !_.find(coverages, { isValid: false }));
    }, [clausesBasePath, submissionVM.value]);

    const isPageLoading = useCallback(() => _.isUndefined(loadingClause), [loadingClause]);

    useEffect(() => {
        registerComponentValidation(isPageLoading);
        registerInitialComponentValidation(shouldPageSkip);
    }, [
        isPageLoading,
        registerComponentValidation,
        registerInitialComponentValidation,
        shouldPageSkip
    ]);

    return (
        <ViewModelForm
            uiProps={metadata.content}
            model={submissionVM.value}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onModelChange={updateWizardData}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );
}

CoveragesPage.propTypes = {
    ...wizardProps
};

export default CoveragesPage;
